import {
  ExpenseList,
  ExpenseType,
  ExpenseVehicle,
} from "Shared/Types/fleetmanagementapi";

import { RootState } from "../store";
import {
  createExpense,
  createExpenseTypes,
  getExpenseDetail,
  getExpenseList,
  getExpenseTypeList,
  getVehiclesListWithExpenses,
  updateExpense,
} from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

interface expenseState {
  loading: boolean;
  expenseList: {
    data: ExpenseList[];
    loading: boolean;
    error?: string | null;
    count: number;
  };
  vehiclesListWithExpenses: {
    data: ExpenseVehicle[];
    loading: boolean;
    error?: string | null;
    count: number;
  };
  expenseTypeList: {
    data: ExpenseType[];
    loading: boolean;
    count: number;
  };
  expenseDetail: {
    data: ExpenseList | null;
    loading: boolean;
  };
  loadingCreate: boolean;
  loadingUpdate: boolean;
  loadingCreateTypes: boolean;
}

const initialState: expenseState = {
  loading: false,
  loadingCreateTypes: false,
  loadingCreate: false,
  expenseTypeList: {
    data: [],
    loading: false,
    count: 0,
  },
  expenseDetail: {
    data: null,
    loading: false,
  },
  loadingUpdate: false,
  expenseList: {
    data: [],
    loading: false,
    error: null,
    count: 0,
  },
  vehiclesListWithExpenses: {
    data: [],
    loading: false,
    error: null,
    count: 0,
  },
};

const Expense = createSlice({
  name: "expense",
  initialState,
  reducers: {
    clear(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExpenseList.pending, (state) => {
      state.expenseList.loading = true;
      state.expenseList.error = null;
    });
    builder.addCase(getExpenseList.fulfilled, (state, action) => {
      state.expenseList.loading = false;
      state.expenseList.error = null;
      state.expenseList.data = action.payload.results;
      state.expenseList.count = action.payload.count;
    });
    builder.addCase(getExpenseList.rejected, (state, action) => {
      state.expenseList.loading = false;
      state.expenseList.error = action.error.message;
    });
    builder.addCase(getVehiclesListWithExpenses.pending, (state) => {
      state.vehiclesListWithExpenses.loading = true;
      state.vehiclesListWithExpenses.error = null;
    });
    builder.addCase(getVehiclesListWithExpenses.fulfilled, (state, action) => {
      state.vehiclesListWithExpenses.loading = false;
      state.vehiclesListWithExpenses.error = null;
      state.vehiclesListWithExpenses.data = action.payload.results;
      state.vehiclesListWithExpenses.count = action.payload.count;
    });
    builder.addCase(getVehiclesListWithExpenses.rejected, (state, action) => {
      state.vehiclesListWithExpenses.loading = false;
      state.vehiclesListWithExpenses.error = action.error.message;
    });
    builder.addCase(createExpense.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createExpense.fulfilled, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(createExpense.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(updateExpense.pending, (state) => {
      state.loadingUpdate = true;
    });
    builder.addCase(updateExpense.fulfilled, (state) => {
      state.loadingUpdate = false;
    });
    builder.addCase(updateExpense.rejected, (state) => {
      state.loadingUpdate = false;
    });
    builder.addCase(createExpenseTypes.pending, (state) => {
      state.loadingCreateTypes = true;
    });
    builder.addCase(createExpenseTypes.fulfilled, (state) => {
      state.loadingCreateTypes = false;
    });
    builder.addCase(createExpenseTypes.rejected, (state) => {
      state.loadingCreateTypes = false;
    });
    builder.addCase(getExpenseTypeList.pending, (state) => {
      state.expenseTypeList.loading = true;
    });
    builder.addCase(getExpenseTypeList.fulfilled, (state, action) => {
      state.expenseTypeList.loading = false;
      state.expenseTypeList.data = action.payload.results;
      state.expenseTypeList.count = action.payload.count;
    });
    builder.addCase(getExpenseTypeList.rejected, (state) => {
      state.expenseTypeList.loading = false;
    });
    builder.addCase(getExpenseDetail.pending, (state) => {
      state.expenseDetail.loading = true;
    });
    builder.addCase(getExpenseDetail.fulfilled, (state, action) => {
      state.expenseDetail.loading = false;
      state.expenseDetail.data = action.payload;
    });
    builder.addCase(getExpenseDetail.rejected, (state) => {
      state.expenseDetail.loading = false;
    });
  },
});

export const { clear } = Expense.actions;

export const selectExpenseListLoading = (state: RootState) =>
  state.expense.expenseList.loading;
export const selectExpenseList = (state: RootState) =>
  state.expense.expenseList.data;
export const selectExpenseListCount = (state: RootState) =>
  state.expense.expenseList.count;
export const selectVehiclesListWithExpenseLoading = (state: RootState) =>
  state.expense.vehiclesListWithExpenses.loading;
export const selectVehiclesListWithExpenseData = (state: RootState) =>
  state.expense.vehiclesListWithExpenses.data;
export const selectVehiclesListWithExpenseCount = (state: RootState) =>
  state.expense.vehiclesListWithExpenses.count;

export const selectExpenseLoadingCreate = (state: RootState) =>
  state.expense.loadingCreate;
export const selectExpenseLoadingUpdate = (state: RootState) =>
  state.expense.loadingUpdate;
export const selectExpenseLoadingCreateTypes = (state: RootState) =>
  state.expense.loadingCreateTypes;
export const selectExpenseTypeList = (state: RootState) =>
  state.expense.expenseTypeList.data;
export const selectExpenseTypeListCount = (state: RootState) =>
  state.expense.expenseTypeList.count;
export const selectExpenseTypeListLoading = (state: RootState) =>
  state.expense.expenseTypeList.loading;
export const selectExpenseDetail = (state: RootState) =>
  state.expense.expenseDetail.data;
export const selectExpenseDetailLoading = (state: RootState) =>
  state.expense.expenseDetail.loading;
export default Expense;
